import React from 'react';
import { connect } from 'react-redux';
import { AppState, Notification } from 'acscp/store';
import { Dispatch } from 'redux';
import { DismissNotification } from 'acscp/actions';
import style from './notificationBar.module.scss';
import { FormattedMessage, InjectedIntlProps, injectIntl } from 'react-intl';
import { CrossIcon } from 'acscp/components/common/icons/crossIcon';
import classNames from 'classnames';
import { NotificationType } from 'acscp/store/notificationState';

interface NotificationBarStateProps {
    notifications: Notification[];
}

interface NotificationBarDispatchProps {
    dismissNotification: (cause: string) => void;
}

const NotificationBarPresentational
    : React.SFC<NotificationBarStateProps & NotificationBarDispatchProps & InjectedIntlProps> = props => {
    if (props.notifications.length === 0) {
        return null;
    }
    return (
        <div className={style.NotificationListContainer}>
            {props.notifications.map((notification, i) => (
                <div
                    className={classNames(style.NotificationBar, {
                    [style.Error]: notification.notificationType === NotificationType.Error,
                    [style.Info]: notification.notificationType === NotificationType.Info })}
                    key={i}
                >
                    <div className={style.NotificationContainer}>
                            <div
                                className={classNames(style.Notification, {
                                    [style.Error]: notification.notificationType === NotificationType.Error,
                                    [style.Info]: notification.notificationType === NotificationType.Info }
                                )}
                            >
                                {typeof(notification.message) === 'string'
                                    ? notification.message
                                    : props.intl.formatMessage(notification.message, notification.messageValues)}
                                <CrossIcon
                                    className={style.Close}
                                    onClick={() => props.dismissNotification(notification.cause)}
                                    aria-label="Dismiss notification"
                                />
                            </div>
                    </div>
                </div>
            ))}
        </div>
    );
};
export { NotificationBarPresentational };

function mapStateToProps(state: AppState, ownProps: {}): NotificationBarStateProps {
    return {
        notifications: state.notifications
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: {}): NotificationBarDispatchProps {
    return {
        dismissNotification: (cause: string) => dispatch(new DismissNotification(cause))
    };
}

export const NotificationBar = connect(mapStateToProps, mapDispatchToProps)(injectIntl(NotificationBarPresentational));
